import ReservationsSkippedModal from './ReservationsSkippedModal';
import TransferWebsiteModal from './TransferWebsiteModal';

export default {
  ReservationsSkippedModal,
  TransferWebsiteModal,
};
